import NotificationTypeEnum from '@constants/enums/notification/type';

import i18n from '@plugins/i18n';

import { Collection, Notification } from '@/models';

export class NotificationCollection extends Collection {
    static type = 'NotificationCollection';
    static endpoint = Notification.api.index;
    static model = Notification;

    static fields() {
        return {
            ...super.fields(),
            user_id: this.string(null).nullable()
        };
    }

    get default_headers() {
        return ['user_name', 'notification', 'type', 'event_at', 'created_at', 'viewed_at', 'deleted_at'];
    }

    get xlsx_headers() {
        return [
            'user_name',
            'user_email',
            'title',
            'body',
            'type',
            'event_at',
            'created_at',
            'viewed_at',
            'deleted_at'
        ];
    }

    get preset_filters() {
        let filters = {};

        if (this.user_id) {
            filters.user_id = this.filterOperator('is') + ':' + this.user_id;
        }

        return filters;
    }

    get headers() {
        return [
            this.createHeader('user_name', i18n.t('user'), {
                filterable: true,
                path: 'user.name',
                width: '18rem'
            }),
            this.createHeader('user_email', i18n.t('user_email'), {
                filterable: true,
                path: 'user.email',
                width: '18rem'
            }),
            this.createHeader('notification', i18n.t('notification'), {
                filterable: false,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('title', i18n.t('title'), {
                filterable: true,
                width: '18rem',
                minWidth: '18rem'
            }),
            this.createHeader('body', i18n.t('body'), {
                filterable: true,
                width: '18rem',
                classList: ['clamp-2']
            }),
            this.createHeader('type', i18n.t('type'), {
                filterable: true,
                width: '16rem',
                format: 'enum',
                enum: NotificationTypeEnum,
                enumA11yKey: 'enums.notification_type'
            }),
            this.createHeader('event_at', i18n.t('event_at'), {
                filterable: true,
                width: '9rem',
                format: 'datetime'
            }),
            this.createHeader('created_at', i18n.t('date_created'), {
                filterable: true,
                width: '9rem',
                format: 'datetime'
            }),
            this.createHeader('viewed_at', i18n.t('date_viewed'), {
                filterable: true,
                width: '9rem',
                format: 'datetime'
            }),
            this.createHeader('deleted_at', i18n.t('date_deleted'), {
                filterable: true,
                width: '9rem',
                format: 'datetime'
            })
        ];
    }
}

export default NotificationCollection;
